var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',_vm._b({attrs:{"to":{
    name: 'LeadersEvent',
    params: {
      main_event_id: _vm.round.main_event_id,
      round: _vm.round.round,
      sub_event_id: _vm.round.sub_event_id
    }
  }}},'router-link',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67f87fe0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Leaders/Listing/components/Links/LinkEvent.vue
// module id = 1030
// module chunks = 30